/* sz-video-cue.js — Shoe Zero
   Adds a visible, on-brand play-button cue to any PAUSED <video> that shows a
   poster but has no cue of its own (the workshop clip, case-study review videos,
   etc.), so a video never reads as a static image. Bound to the video's paused
   state: the button shows while paused and hides once it plays.

   SKIPS:  ambient autoplay+loop background videos (hero), and videos that already
           have their own play affordance (.oB-vid-play, .hp2-vplay).
   REVERSIBLE: delete this asset + its one <script> line in layout/theme.liquid.
*/
(function () {
  if (window.__szVideoCue) return;
  window.__szVideoCue = true;

  var CSS =
    '.sz-cue{position:absolute;display:flex;align-items:center;justify-content:center;z-index:4;border:0;padding:0;margin:0;background:transparent;cursor:pointer;transition:opacity .3s cubic-bezier(.22,1,.36,1);}' +
    '.sz-cue::before{content:"";position:absolute;inset:0;background:radial-gradient(circle at center,rgba(0,0,0,.18),rgba(0,0,0,0) 60%);pointer-events:none;}' +
    '.sz-cue__btn{position:relative;width:72px;height:72px;border-radius:50%;background:rgba(255,255,255,.94);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);display:flex;align-items:center;justify-content:center;box-shadow:0 1px 2px rgba(0,0,0,.06),0 6px 18px rgba(0,0,0,.16),0 16px 40px rgba(0,0,0,.18);transition:transform .3s cubic-bezier(.22,1,.36,1),background .2s ease;}' +
    '.sz-cue__btn svg{width:26px;height:26px;margin-left:4px;color:#00704a;fill:currentColor;}' +
    '.sz-cue:hover .sz-cue__btn{transform:scale(1.08);background:#fff;}' +
    '.sz-cue.is-playing{opacity:0;pointer-events:none;}' +
    '@media (prefers-reduced-motion:reduce){.sz-cue{transition:none;}}';

  var style = document.createElement('style');
  style.setAttribute('data-sz-cue', '');
  style.textContent = CSS;
  (document.head || document.documentElement).appendChild(style);

  var ICON = '<span class="sz-cue__btn"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg></span>';

  function qualifies(v) {
    if (v.dataset.szCue) return false;                                  // already handled
    if (v.hasAttribute('autoplay') && v.hasAttribute('loop')) return false; // ambient background loop
    var host = v.parentElement;
    if (host && host.querySelector('.oB-vid-play, .hp2-vplay')) return false; // already has a cue
    return true;
  }

  function place(btn, v) {
    // Overlay exactly the video's box (handles portrait videos centered in a wider column).
    btn.style.left = v.offsetLeft + 'px';
    btn.style.top = v.offsetTop + 'px';
    btn.style.width = v.offsetWidth + 'px';
    btn.style.height = v.offsetHeight + 'px';
  }

  function attach(v) {
    if (!qualifies(v)) return;
    v.dataset.szCue = '1';
    var host = v.parentElement;
    if (!host) return;
    if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sz-cue';
    var al = v.getAttribute('aria-label');
    btn.setAttribute('aria-label', al ? ('Play: ' + al) : 'Play video');
    btn.innerHTML = ICON;

    btn.addEventListener('click', function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); });
    v.addEventListener('play', function () { btn.classList.add('is-playing'); });
    v.addEventListener('pause', function () { btn.classList.remove('is-playing'); });
    v.addEventListener('ended', function () { btn.classList.remove('is-playing'); });
    if (!v.paused && !v.ended) btn.classList.add('is-playing');

    host.appendChild(btn);
    place(btn, v);
    // keep the overlay aligned as the video lays out / on resize
    if (v.readyState >= 1) place(btn, v);
    v.addEventListener('loadedmetadata', function () { place(btn, v); });
    window.addEventListener('resize', function () { place(btn, v); });
  }

  function scan() {
    var vids = document.querySelectorAll('video');
    for (var i = 0; i < vids.length; i++) attach(vids[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  window.addEventListener('load', scan);
})();
